import React,{useState, useEffect} from "react";
import { Link } from "react-router-dom";
import api from "../../../api/api";

const DesignAndPrint = () => {
  // const data = [
  //   {
  //     nepaliText: "क्यालेन्डर छपाई",
  //     englishText: "Calender Printing",
  //     component: "CalenderPrinting",
  //     path: "calender-printing",
  //     backText:
  //       "Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder",
  //   },

  //   {
  //     nepaliText: "भि–कार्ड छपाई",
  //     englishText: "V-Card Printing",
  //     component: "VCardPrinting",
  //     path: "vcard-printing",
  //     backText:
  //       "Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder",
  //   },
  //   {
  //     nepaliText: "ब्रोसर छपाई",
  //     englishText: "Brochure Printing",
  //     backText:
  //       "Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder",
  //   },
  //   {
  //     nepaliText: "बिलहरु छपाई",
  //     englishText: "Bill Printing",
  //     component: "BillPrinting",
  //     path: "bill-printing",
  //     backText:
  //       "Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder ",
  //   },
  //   {
  //     nepaliText: "लेटरप्याड छपाई",
  //     englishText: "Letter Head Printing",
  //     backText:
  //       "Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder ",
  //   },
  //   {
  //     nepaliText: "अन्य छपाईहरु",
  //     englishText: "Other Printing",
  //     backText:
  //       "Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder ",
  //   },
  //   {
  //     nepaliText: "साधा तथा रंगिन डिजाईन",
  //     englishText: "Color & BW Design",
  //     backText:
  //       "Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder ",
  //   },
  //   {
  //     nepaliText: "डिजीटल छाप",
  //     englishText: "Digital Stamp Making",
  //     backText:
  //       "Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder ",
  //   },
  // ];

  
  const [services, setServices] = useState([])

  useEffect(() => {
    api.get('/design-and-printing/types/')
    .then(response=> {
      setServices(response.data)
    }).catch(error=> {
      console.log(error)
    })
  }, [])


  return (
    <div className="w-full w-padding">
      <div className="max-w">
        <div className="service-box business mt-10">
          <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-6">
            {/* private company registration  */}
            {services.map((value, index) => {
              // console.log("codNam", value.codename)
              return (
                <div key={index} className="flip-container w-full">
                  <div className="flipper h-full w-full">
                    <div className="front bg-primary-blue relative h-full w-full overflow-hidden">
                      {/*  */}
                      <span className="ribbon-tr" />
                      <span className="ribbon-bl" />
                      <span className="ribbon-br" />
                      <div className="h-full w-full">
                        <div className="item slider-card">
                          <div className="slider-child">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 32 32"
                              className="slider-icon"
                            >
                              <defs>
                                <style
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      "\n                              .cls-1 {\n                                fill: none;\n                                stroke: currentColor;\n                                stroke-linecap: round;\n                                stroke-linejoin: round;\n                                stroke-width: 2px;\n                              }\n                            ",
                                  }}
                                />
                              </defs>
                              <title />
                              <g data-name="79-users" id="_79-users">
                                <circle
                                  className="cls-1"
                                  cx={16}
                                  cy={13}
                                  r={5}
                                />
                                <path
                                  className="cls-1"
                                  d="M23,28A7,7,0,0,0,9,28Z"
                                />
                                <path
                                  className="cls-1"
                                  d="M24,14a5,5,0,1,0-4-8"
                                />
                                <path
                                  className="cls-1"
                                  d="M25,24h6a7,7,0,0,0-7-7"
                                />
                                <path
                                  className="cls-1"
                                  d="M12,6a5,5,0,1,0-4,8"
                                />
                                <path
                                  className="cls-1"
                                  d="M8,17a7,7,0,0,0-7,7H7"
                                />
                              </g>
                            </svg>
                          </div>
                          <h1 className="slider-h1 text-base">
                            <div className="font-Fondamento ">
                              {value.name}
                            </div>
                            <div className="font-Kalam ">
                              {value.name}
                            </div>
                          </h1>
                        </div>
                      </div>
                    </div>
                    <div className="back h-full w-full">
                      <div className="bg-primary-blue h-full w-full rounded-tl-[4rem] rounded-br-[4rem]">
                        <div className="flex h-full w-full flex-col items-center justify-center p-3 text-white">
                          <div className="font-Acme text-lg font-medium">
                            {/* {value.backText} */}
                            {/* "Up to 7 share holders rs: 12,000 More Than will be added rs 500/share holder" */}

                            {value.description}

                          </div>
                          <div className="mt-4">
                            <Link
                              state={{
                                englishText: value.name,
                                nepaliText: value.name,
                                component: "DynamicDesignAndPrinting",
                                path: value.codename,
                              }}
                              to="service-details"
                              className="bg-primary-green font-Berkshire rounded-2xl px-6 py-2 text-sm"
                            >
                              Details
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignAndPrint;
